"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/search.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fsearch.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchedStockEnrollment = exports.MatchedCryptoEnrollment = exports.MatchedAccount = exports.MatchedReferralCode = exports.MatchedProfileMatchedAlias = exports.MatchedProfile = exports.MatchedUser = void 0;
const alias_1 = require("./alias");
const legal_name_1 = require("./legal-name");
const protobufPackage = 'com.step.common.proto';
function createBaseMatchedUser() {
    return {
        userId: '',
        legalName: legal_name_1.LegalName.fromPartial({}),
        isDirectMatch: false,
        isVerified: false,
    };
}
exports.MatchedUser = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            legalName: isSet(object.legalName)
                ? legal_name_1.LegalName.fromJSON(object.legalName)
                : legal_name_1.LegalName.fromPartial({}),
            isDirectMatch: isSet(object.isDirectMatch) ? globalThis.Boolean(object.isDirectMatch) : false,
            isVerified: isSet(object.isVerified) ? globalThis.Boolean(object.isVerified) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        if (message.isDirectMatch !== false) {
            obj.isDirectMatch = message.isDirectMatch;
        }
        if (message.isVerified !== false) {
            obj.isVerified = message.isVerified;
        }
        return obj;
    },
    create(base) {
        return exports.MatchedUser.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMatchedUser();
        message.userId = object.userId ?? '';
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : legal_name_1.LegalName.fromPartial({});
        message.isDirectMatch = object.isDirectMatch ?? false;
        message.isVerified = object.isVerified ?? false;
        return message;
    },
};
function createBaseMatchedProfile() {
    return { userId: '', alias: alias_1.Alias.fromPartial({}), aliases: [] };
}
exports.MatchedProfile = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            alias: isSet(object.alias) ? alias_1.Alias.fromJSON(object.alias) : alias_1.Alias.fromPartial({}),
            aliases: globalThis.Array.isArray(object?.aliases)
                ? object.aliases.map((e) => exports.MatchedProfileMatchedAlias.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.alias !== undefined) {
            obj.alias = alias_1.Alias.toJSON(message.alias);
        }
        if (message.aliases?.length) {
            obj.aliases = message.aliases.map((e) => exports.MatchedProfileMatchedAlias.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.MatchedProfile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMatchedProfile();
        message.userId = object.userId ?? '';
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? alias_1.Alias.fromPartial(object.alias)
            : alias_1.Alias.fromPartial({});
        message.aliases = object.aliases?.map((e) => exports.MatchedProfileMatchedAlias.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMatchedProfileMatchedAlias() {
    return { alias: alias_1.Alias.fromPartial({}), isVerified: false, isDirectMatch: false };
}
exports.MatchedProfileMatchedAlias = {
    fromJSON(object) {
        const message = {
            alias: isSet(object.alias) ? alias_1.Alias.fromJSON(object.alias) : alias_1.Alias.fromPartial({}),
            isVerified: isSet(object.isVerified) ? globalThis.Boolean(object.isVerified) : false,
            isDirectMatch: isSet(object.isDirectMatch) ? globalThis.Boolean(object.isDirectMatch) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.alias !== undefined) {
            obj.alias = alias_1.Alias.toJSON(message.alias);
        }
        if (message.isVerified !== false) {
            obj.isVerified = message.isVerified;
        }
        if (message.isDirectMatch !== false) {
            obj.isDirectMatch = message.isDirectMatch;
        }
        return obj;
    },
    create(base) {
        return exports.MatchedProfileMatchedAlias.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMatchedProfileMatchedAlias();
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? alias_1.Alias.fromPartial(object.alias)
            : alias_1.Alias.fromPartial({});
        message.isVerified = object.isVerified ?? false;
        message.isDirectMatch = object.isDirectMatch ?? false;
        return message;
    },
};
function createBaseMatchedReferralCode() {
    return { userId: '', code: '', isDirectMatch: false };
}
exports.MatchedReferralCode = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            code: isSet(object.code) ? globalThis.String(object.code) : '',
            isDirectMatch: isSet(object.isDirectMatch) ? globalThis.Boolean(object.isDirectMatch) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.code !== '') {
            obj.code = message.code;
        }
        if (message.isDirectMatch !== false) {
            obj.isDirectMatch = message.isDirectMatch;
        }
        return obj;
    },
    create(base) {
        return exports.MatchedReferralCode.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMatchedReferralCode();
        message.userId = object.userId ?? '';
        message.code = object.code ?? '';
        message.isDirectMatch = object.isDirectMatch ?? false;
        return message;
    },
};
function createBaseMatchedAccount() {
    return {
        userId: '',
        accountPrimaryId: '',
        accountNumber: undefined,
        achAccountNumber: undefined,
        isDirectMatch: false,
    };
}
exports.MatchedAccount = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            accountPrimaryId: isSet(object.accountPrimaryId)
                ? globalThis.String(object.accountPrimaryId)
                : '',
            isDirectMatch: isSet(object.isDirectMatch) ? globalThis.Boolean(object.isDirectMatch) : false,
        };
        if (isSet(object.accountNumber)) {
            message.accountNumber = globalThis.String(object.accountNumber);
        }
        if (isSet(object.achAccountNumber)) {
            message.achAccountNumber = globalThis.String(object.achAccountNumber);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.accountPrimaryId !== '') {
            obj.accountPrimaryId = message.accountPrimaryId;
        }
        if (message.accountNumber !== undefined) {
            obj.accountNumber = message.accountNumber;
        }
        if (message.achAccountNumber !== undefined) {
            obj.achAccountNumber = message.achAccountNumber;
        }
        if (message.isDirectMatch !== false) {
            obj.isDirectMatch = message.isDirectMatch;
        }
        return obj;
    },
    create(base) {
        return exports.MatchedAccount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMatchedAccount();
        message.userId = object.userId ?? '';
        message.accountPrimaryId = object.accountPrimaryId ?? '';
        message.accountNumber = object.accountNumber ?? undefined;
        message.achAccountNumber = object.achAccountNumber ?? undefined;
        message.isDirectMatch = object.isDirectMatch ?? false;
        return message;
    },
};
function createBaseMatchedCryptoEnrollment() {
    return { userId: '', participantCode: '', isDirectMatch: false };
}
exports.MatchedCryptoEnrollment = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            participantCode: isSet(object.participantCode)
                ? globalThis.String(object.participantCode)
                : '',
            isDirectMatch: isSet(object.isDirectMatch) ? globalThis.Boolean(object.isDirectMatch) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.participantCode !== '') {
            obj.participantCode = message.participantCode;
        }
        if (message.isDirectMatch !== false) {
            obj.isDirectMatch = message.isDirectMatch;
        }
        return obj;
    },
    create(base) {
        return exports.MatchedCryptoEnrollment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMatchedCryptoEnrollment();
        message.userId = object.userId ?? '';
        message.participantCode = object.participantCode ?? '';
        message.isDirectMatch = object.isDirectMatch ?? false;
        return message;
    },
};
function createBaseMatchedStockEnrollment() {
    return {
        userId: '',
        externalUserId: '',
        externalAccountId: undefined,
        externalAccountNumber: undefined,
        isDirectMatch: false,
    };
}
exports.MatchedStockEnrollment = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            externalUserId: isSet(object.externalUserId) ? globalThis.String(object.externalUserId) : '',
            isDirectMatch: isSet(object.isDirectMatch) ? globalThis.Boolean(object.isDirectMatch) : false,
        };
        if (isSet(object.externalAccountId)) {
            message.externalAccountId = globalThis.String(object.externalAccountId);
        }
        if (isSet(object.externalAccountNumber)) {
            message.externalAccountNumber = globalThis.String(object.externalAccountNumber);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.externalUserId !== '') {
            obj.externalUserId = message.externalUserId;
        }
        if (message.externalAccountId !== undefined) {
            obj.externalAccountId = message.externalAccountId;
        }
        if (message.externalAccountNumber !== undefined) {
            obj.externalAccountNumber = message.externalAccountNumber;
        }
        if (message.isDirectMatch !== false) {
            obj.isDirectMatch = message.isDirectMatch;
        }
        return obj;
    },
    create(base) {
        return exports.MatchedStockEnrollment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMatchedStockEnrollment();
        message.userId = object.userId ?? '';
        message.externalUserId = object.externalUserId ?? '';
        message.externalAccountId = object.externalAccountId ?? undefined;
        message.externalAccountNumber = object.externalAccountNumber ?? undefined;
        message.isDirectMatch = object.isDirectMatch ?? false;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=search.js.map